import React from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { createGlobalStyle } from "styled-components";

const DatePickerWrapperStyles = createGlobalStyle`
  .rmdp-wrapper {
    font-family: IRANSansBold;
  }
  .rmdp-today span,
  .rmdp-day.rmdp-selected span:not(.highlight) {
    background-color: #fcc900 !important;
    color: black !important;
  }
`;

export default function BirthDate({
  title,
  required = false,
  setDateOfBirth,
  dateOfBirth,
  checkAge,
}) {
  return (
    <div className="w-full mb-4">
      {title ? (
        <div className="w-full mb-2 flex justify-start items-center text-medium font-IRANSansBold">
          {title}
          {required ? <span className="text-scabRed mr-1">*</span> : null}
        </div>
      ) : null}
      <DatePicker
        inputMode="none"
        containerStyle={{ width: "100%" }}
        value={dateOfBirth || ""}
        onChange={setDateOfBirth}
        placeholder="انتخاب کنید"
        calendar={persian}
        locale={persian_fa}
        style={{
          fontSize: "14px",
          fontWeight: 700,
          width: "100%",
          height: "44px",
          borderRadius: "12px",
          paddingRight: "12px",
          color: checkAge ? "#FF0000" : "#000",
          fontFamily: "IRANSansBold",
          border: checkAge ? "1px solid #FF0000" : "1px solid #B9B9B9",
        }}
      />
      <DatePickerWrapperStyles />
    </div>
  );
}
